import { createBrowserRouter, Navigate } from "react-router-dom";
import { LocaleFallbackRedirect, SellerLocaleLayout } from "./locale";
import { ProtectedLayout } from "./ProtectedLayout";
import { ProtectedEditorLayout } from "./ProtectedEditorLayout";
import { ProtectedOnboardingLayout } from "./ProtectedOnboardingLayout";
import { dashboardRoutes } from "../modules/dashboard/routes";
import { authRoutes } from "../modules/auth/routes";
import { categoriesRoutes } from "../modules/categories/routes";
import { couponsRoutes, discountsRoutes } from "../modules/coupons/routes";
import { customersRoutes } from "../modules/customers/routes";
import { inviteRoutes } from "../modules/invite/routes";
import { teamRoutes } from "../modules/team/routes";
import { orderRoutes } from "../modules/orders/routes";
import { transactionsRoutes } from "../modules/transactions/routes";
import { productRoutes } from "../modules/products/routes";
import { profileRoutes } from "../modules/profile/routes";
import { pwaRoutes } from "../modules/pwa/routes";
import { reviewsRoutes } from "../modules/reviews/routes";
import { rootRoutes } from "../modules/root/routes";
import { settingsRoutes } from "../modules/settings/routes";
import { storeEditorRoutes } from "../modules/store-editor/routes";
import { accountRoutes } from "../modules/account/routes";
import { onboardingRoutes } from "../modules/onboarding/routes";

export const sellerRouter = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/ar/login" replace />,
  },
  {
    path: "/:locale",
    element: <SellerLocaleLayout />,
    children: [
      ...rootRoutes,
      ...authRoutes,
      ...inviteRoutes,
      ...teamRoutes,
      {
        // Editor occupies the full viewport; uses its own auth wrapper that
        // skips the standard sidebar/topbar chrome (`AppShell`).
        path: ":storeSlug",
        element: <ProtectedEditorLayout />,
        children: [...storeEditorRoutes],
      },
      {
        // Quick Setup onboarding occupies the full viewport (no sidebar),
        // matching the full-screen onboarding design.
        path: ":storeSlug",
        element: <ProtectedOnboardingLayout />,
        children: [...onboardingRoutes],
      },
      {
        path: ":storeSlug",
        element: <ProtectedLayout />,
        children: [
          ...dashboardRoutes,
          ...profileRoutes,
          ...settingsRoutes,
          ...categoriesRoutes,
          ...productRoutes,
          ...orderRoutes,
          ...transactionsRoutes,
          ...reviewsRoutes,
          ...couponsRoutes,
          ...discountsRoutes,
          ...customersRoutes,
          ...accountRoutes,
          ...pwaRoutes,
        ],
      },
      {
        path: "*",
        element: <LocaleFallbackRedirect />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/ar/login" replace />,
  },
]);
